import React, {useState, useRef} from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Grid from '@material-ui/core/Grid';
import { ListItemIcon, ListItemText } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import DeleteIcon from '@material-ui/icons/Delete';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import CheckIcon from '@material-ui/icons/Check';
import { TextField } from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    button: {
      textTransform: 'none'
    }, 
    textFieldMedium: {
        width: '30ch',
    },
    textFieldLarge: {
        width: '60ch',
    },
})); 

export function SubWorkstreamChip({workstream, canDelete ,onEdit, onDelete, onEnableDisable}) {
    return (       
        <EditableLabelButton label={workstream.name}  id={workstream.id}
            canDisable={true} 
            canDelete={canDelete}
            disabled={workstream.is_disabled} 
            onEdit={onEdit} 
            onDelete={onDelete} 
            onEnableDisable={onEnableDisable} />  
    ); 
};

export function WorkstreamChip({workstream, canDelete, onEdit, onDelete}) {
    return (       
        <EditableLabelButton label={workstream.name} id={workstream.id}
            disabled={false}
            canDisable={false}
            canDelete={canDelete} 
            onEdit={onEdit} 
            onDelete={onDelete}
            size="medium" />  
    ); 
};

 function EditableLabelButton({label, id, disabled, canDisable, canDelete, onDelete, onEdit, onEnableDisable, size="large"}) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [isRenaming, setIsRenaming] = useState(false);
    const [labelText, setLabelText] = useState(label);
    const [isDisabled, setIsDisabled] = useState(disabled);
  
    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };
  
    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
  
      setOpen(false);
    };

    const handleOnClick = () => {
        setIsRenaming(true);
        setOpen(false);
    };

    const handleKeyPress = (event) => {
        if(event.keyCode === 13){
            const value = event.target.value;
            if(value) {
                onEdit(value, onRenameComplete);
            }
        }

        if(event.keyCode === 27) {
            setIsRenaming(false);
        }
    };

    const onRenameComplete = (value) => {
        setLabelText(value);
        setIsRenaming(false);
    };

    const handleEnableDisable = () => {
        onEnableDisable(!isDisabled, onEnableDisableComplete);
    };

    const onEnableDisableComplete = (isDisabled) => {
        setIsDisabled(isDisabled);
        setOpen(false);
    };

    return (
        <Grid item>
            { !isRenaming && <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
                { !isRenaming && <Button className={classes.button} disabled={isDisabled} onClick={handleOnClick}>{labelText}</Button> }               
                <Button
                    color="primary"
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}>
                    <MoreVertIcon />
                </Button>
            </ButtonGroup> }
            { isRenaming &&  <TextField
                    defaultValue={labelText}
                    autoFocus
                    margin="dense"
                    type="text"
                    className={size === 'large' ? classes.textFieldLarge : classes.textFieldMedium}
                    variant="outlined"
                    onKeyDown={handleKeyPress}
                    onBlur={() => setIsRenaming(false)} /> }
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal={false}>
            {({ TransitionProps, placement }) => (
                <Grow
                {...TransitionProps}
                style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }}
                >
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                    <MenuList id={`split-button-menu-${label}`}>  
                        { !isDisabled && <MenuItem
                            key={`rename-${id}`}
                            onClick={handleOnClick}>
                            <ListItemIcon>
                                <BorderColorIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Rename" />
                        </MenuItem> }                     
                        { canDisable && <MenuItem
                            key={`disable-${id}`}
                            onClick={handleEnableDisable}>
                            <ListItemIcon>
                                { isDisabled && <CheckIcon fontSize="small" /> }
                                { !isDisabled && <BlockIcon fontSize="small" /> }
                            </ListItemIcon>
                            <ListItemText primary={ isDisabled ? 'Enable' : 'Disable' } />
                        </MenuItem> }
                        { (!isDisabled && canDelete) && <MenuItem
                            key={`delete-${id}`}
                            onClick={onDelete}>
                            <ListItemIcon>
                                <DeleteIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Delete" />
                        </MenuItem> }
                    </MenuList>
                    </ClickAwayListener>
                </Paper>
                </Grow>
            )}
            </Popper>
        </Grid>
    );
 }